import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";
import { getStaticSeoForPath } from "../../utils/seo";
import { useTranslation } from "../../i18n/LanguageProvider";

function RouteSeo() {
    const location = useLocation();
    const { language } = useTranslation();
    const seo = useMemo(() => getStaticSeoForPath(location.pathname, language), [language, location.pathname]);

    useSeo(seo);

    return null;
}

export default RouteSeo;
